import { render, staticRenderFns } from "./EditPublisherModal.vue?vue&type=template&id=4000140a&lang=pug&"
import script from "./EditPublisherModal.vue?vue&type=script&lang=js&"
export * from "./EditPublisherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports